import styled from 'styled-components';

export const TabList = styled.div`
    display: flex;
    align-items: center;
    gap: 2px;
    padding: 2px;
    border-radius: var(--radius-md, 8px);
    background: var(--color-muted);
`;

export const TabButton = styled.button<{ $isActive: boolean }>`
    display: inline-flex;
    align-items: center;
    gap: var(--space-1, 6px);
    height: 28px;
    padding: 0 11px;
    border: 0;
    border-radius: var(--radius-sm, 6px);
    font-size: var(--font-size-xs, 12px);
    font-weight: 550;
    white-space: nowrap;
    cursor: pointer;
    color: ${({ $isActive }) =>
        $isActive ? 'var(--color-foreground)' : 'var(--color-muted-foreground)'};
    background: ${({ $isActive }) => ($isActive ? 'var(--color-background)' : 'transparent')};
    box-shadow: ${({ $isActive }) => ($isActive ? '0 0 0 1px var(--color-border)' : 'none')};

    svg {
        width: 13px;
        height: 13px;
    }

    &:hover {
        color: var(--color-foreground);
    }

    &:focus-visible {
        outline: 2px solid var(--micro-app-accent-focus, var(--color-ring));
        outline-offset: 1px;
    }
`;

export const TabCount = styled.span`
    display: inline-flex;
    min-width: 17px;
    height: 17px;
    align-items: center;
    justify-content: center;
    padding: 0 var(--space-1, 5px);
    border-radius: 999px;
    font-size: var(--font-size-xs, 10px);
    color: var(--color-muted-foreground);
    background: var(--color-border);
`;
